import * as Yup from 'yup';
import { SarlaftOperations } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftOperations = {
    typeProduct: '',
    numberProduct: '',
    entity: '',
    amount: '',
    foreignCity: '',
    country: '',
    currency: '',
};

export const validationSchema = Yup.object({
    typeProduct: Yup.string().required('El tipo de producto es obligatorio'),
    numberProduct: Yup.string().required(
        'El número de producto es obligatorio'
    ),
    entity: Yup.string().required('La entidad es obligatoria'),
    amount: Yup.string().required('El monto es obligatorio'),
    foreignCity: Yup.string().required('La ciudad es obligatoria'),
    country: Yup.string().required('El país es obligatorio'),
    currency: Yup.string().required('La moneda es obligatoria'),
});
